import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { ArrowRight, CheckCircle } from "lucide-react";
import corporateDashboard from "@/assets/corporate-dashboard.png";

export default function LandingHero({ onScheduleDemo }: { onScheduleDemo: () => void }) {
  return (
    <section className="relative min-h-[85vh] flex items-center pt-24 pb-20">
      <div className="max-w-7xl mx-auto px-6 w-full">
        <div className="grid md:grid-cols-5 gap-12 items-center">
          <div className="md:col-span-3 space-y-8">
            <Badge variant="secondary" className="text-xs uppercase tracking-wide">
              All-in-One Sales Team Platform
            </Badge>

            <h1 className="text-5xl md:text-6xl font-bold leading-tight">
              AI-Driven Platform Designed to Help Sales Teams Grow
            </h1>

            <p className="text-lg text-muted-foreground leading-relaxed max-w-2xl">
              Replace all of your platforms with just one solution. AMPA Network, your all in one software for every sales teams across all industries.
            </p>

            <div className="flex flex-wrap gap-4">
              <Button
                size="lg"
                className="text-base px-8 bg-[#3b82f6] hover:bg-[#3b82f6]/90"
                onClick={onScheduleDemo}
              >
                Schedule a Demo
                <ArrowRight className="ml-2 h-4 w-4" />
              </Button>
            </div>

            <div className="flex flex-wrap gap-6 text-sm text-muted-foreground">
              <span className="flex items-center gap-2">
                <CheckCircle className="h-4 w-4 text-[#3b82f6]" /> Team Collaboration
              </span>
              <span className="flex items-center gap-2">
                <CheckCircle className="h-4 w-4 text-[#3b82f6]" /> AI Automation
              </span>
              <span className="flex items-center gap-2">
                <CheckCircle className="h-4 w-4 text-[#3b82f6]" /> Advanced Analytics
              </span>
            </div>
          </div>

          <div className="md:col-span-2">
            <img
              src={corporateDashboard}
              alt="AMPA Network Dashboard Preview"
              className="rounded-xl border shadow-xl w-full object-cover"
            />
          </div>
        </div>
      </div>
    </section>
  );
}
